import React, {FC, useEffect, useState} from "react";
import axios from "axios";
import MultichainPortfolioTableList from "../../common/multichain-portfolio-table-list";
import {MULTICHAIN_LIST} from "../../../common/utils/constants";
import {useParams} from "react-router";
import useCommon from "../../../common/hooks/useCommon";
import {toXDCNumber} from "../../../common/utils/function";
import {useTranslation} from "react-i18next";

interface ChainData {
    id: number;
    name: string;
    logoUrl: string;
    totalValue: string;
    totalValuePercentage: string;
    chaindata: string;
}

const MultiselectportfoliodataList: FC<any> = (props) => {
    const {address} = useParams();
    const {getXDC} = useCommon();
    const [showAllChains, setShowAllChains] = useState(false);
    const {t, i18n} = useTranslation();
    const [selectedChains, setSelectedChains] = useState<string[]>([]);
    const [chainInfo, setChainInfo] = useState([]);
    const [chainTokenInfo, setChainTokenInfo] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const apiInfo: any = await Promise.all(
                    MULTICHAIN_LIST.map(async (apiData) => {
                        try {
                            const res = await axios.get(
                                `${apiData.API}/addresses/${address}`
                            );
                            if (res.status === 200) {
                                return {
                                    ...apiData,
                                    balance: res?.data?.coin_balance,
                                    has_tokens: res?.data?.has_tokens,
                                    exchange_rate: res?.data?.exchange_rate || res?.data?.token?.exchange_rate,
                                    hash: res?.data?.hash,
                                    fiat_value: res?.data?.fiat_value,
                                };
                            } else {
                                return apiData;
                            }
                        } catch (error: any) {
                            return apiData;
                        }
                    })
                );
                setChainInfo(apiInfo);
                const allChainName = apiInfo.map((ele: any) => ele.Name);
                setSelectedChains(allChainName);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, []);

    useEffect(() => {
        const fetchChainTokenData = async () => {
            try {
                const apiInfo: any = await Promise.all(
                    chainInfo.map(async (apiData: any) => {
                        if (apiData.has_tokens) {
                            try {
                                const res = await axios.get(
                                    `${apiData.API}/addresses/${address}/tokens`
                                );
                                if (res.status === 200) {
                                    return {
                                        ...apiData,
                                        tokenList: res?.data,
                                    };
                                } else {
                                    return apiData;
                                }
                            } catch (error: any) {
                                return apiData;
                            }
                        } else {
                            return apiData;
                        }
                    })
                );
                setChainTokenInfo(apiInfo);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        fetchChainTokenData();
    }, [chainInfo]);

    const toggleShowAllChains = () => {
        setShowAllChains(!showAllChains);
    };

    const handleChainClick = (chainName: string) => {
        setSelectedChains((prevSelected) => {
            if (prevSelected.includes(chainName)) {
                return prevSelected.filter(
                    (selectedChain) => selectedChain !== chainName
                );
            } else {
                return [...prevSelected, chainName];
            }
        });
    };

    const totalValueOfSelectedChains = selectedChains?.reduce(
        (acc, selectedChain) => {
            const chain: any = chainInfo.find(
                (chain: any) => chain.Name === selectedChain
            );
            if (chain && chain?.balance) {
                return (
                    acc +
                    parseInt(
                        toXDCNumber(Number(chain?.fiat_value) * Number(chain?.balance))
                    )
                );
            }
            return acc;
        },
        0
    );

    const totalValueOfAllChains = chainInfo.reduce((acc: any, chain: any) => {
        const value = parseInt(
            toXDCNumber(Number(chain?.fiat_value) * Number(chain?.balance))
        );
        return acc + value;
    }, 0);

    useEffect(() => {
        props.getTotalValue(totalValueOfAllChains);
    }, [totalValueOfAllChains]);

    const renderChains = () => {
        const visibleChains = showAllChains
            ? chainTokenInfo
            : chainTokenInfo.slice(0, 2);
        return visibleChains.map((chain: any, index) => (
            <div
                key={index}
                className={`col-6 col-md-3 col-xl-2`}
                data-chain={chain.Name}
            >
                <a
                    href="javascript:"
                    className={`card bg-address-multichain-tab h-100 shadow-none rounded p-2 ${
                        selectedChains.includes(chain.Name) ? "selected-bg-color" : ""
                    }`}
                    onClick={() => handleChainClick(chain.Name)}
                >
                    <div className="d-flex align-items-center gap-1 mb-1">
                        <img
                            src={`${process.env.REACT_APP_BASE_URL}/tokens/img/${chain?.Symbol}.png`}
                            alt="OpenScan.ai"
                            className="xdc-nav__logo logo-light"
                            style={{width: "26px", height: "26px"}}
                        />
                        {/* <TokenImage image={""} symbol={chain?.symbol}
                        params={{width: 26, height:26, className: "bs-icon-avatar mr-2"}}/> */}
                        <span className="text-muted small">
                            {chain.Name}{" "}
                            <span className="text-muted">
                                ({chain?.tokenList?.items?.length || 0})
                            </span>
                        </span>
                    </div>
                    <div>
                        {/* <div className="text-muted mb-n0.5 ms-1">
              {chain.totalValue} <span className=" text-muted small">({chain.totalValuePercentage})</span>
            </div> */}
                    </div>
                </a>
            </div>
        ));
    };

    return (
        <div className="bs-card">
            <div className="bs-card-header py-3 px-4 d-flex flex-column gap-3">
                <div className="d-flex align-items-center justify-content-between">
                    <h2>
                        <span className="bs-card-header-title"> {t("Tokens")} </span>
                        <span className="text-muted">
                            | {chainInfo.length} {t("Chains")}
                        </span>
                    </h2>
                    <div className="d-flex flex-wrap align-items-center gap-2">
                        {chainInfo.length > 2 && (
                            <a
                                className="small link-secondary text-decoration-underline"
                                href="javascript:"
                                onClick={toggleShowAllChains}
                            >
                                {showAllChains
                                    ? `"${t("Hide All Chains")}`
                                    : `${t("Display All Chains")}`}
                            </a>
                        )}
                        <span>•</span>
                        {/* <div className="small text-muted">
              Last updated: <span className="text-dark">less than 1 sec ago</span>
            </div> */}
                    </div>
                </div>

                <div className="row g-2">
                    {/* Render chains */}
                    {renderChains()}
                    {/* Toggle Button */}
                    {chainInfo.length > 2 && (
                        <div className="col-6 col-md-3 col-xl-2">
                            <div className="d-flex align-items-center h-100 px-3">
                                <button
                                    onClick={toggleShowAllChains}
                                    className="text-muted bg-address-multichain-toggle small text-decoration-underline"
                                >
                                    {showAllChains ? (
                                        <span>
                                            <i className="bi bi-dash"></i> {t("Hide Chains")}
                                        </span>
                                    ) : (
                                        <span>
                                            <i className="bi bi-plus"></i> {t("Show More Chains")}
                                        </span>
                                    )}
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <MultichainPortfolioTableList
                selectedChain={selectedChains}
                totalChains={chainInfo.length}
                totalValueselected={totalValueOfSelectedChains}
                totalValue={totalValueOfAllChains}
                chainTokenInfo={chainTokenInfo}
            />
        </div>
    );
};

export default MultiselectportfoliodataList;
